import { api, unwrap } from '@/api'
import type { CustomerPermissionsSummary, CustomerSubscriptionSummary } from '@/modules/customer'
import type { DealerDashboardData, DealerUsageLimits } from '../types/dealer.types'

export const dealerService = {
  async getDashboard(): Promise<DealerDashboardData> {
    const res = await api.get<DealerDashboardData>('/dealer/dashboard')
    return unwrap(res)
  },

  async getVehicles(): Promise<{ totalCars: number }> {
    const res = await api.get<{ totalCars: number }>('/dealer/vehicles')
    return unwrap(res)
  },

  async getParts(): Promise<{ totalParts: number }> {
    const res = await api.get<{ totalParts: number }>('/dealer/parts')
    return unwrap(res)
  },

  async getUsage(): Promise<DealerUsageLimits> {
    const res = await api.get<DealerUsageLimits>('/dealer/usage')
    return unwrap(res)
  },

  async getSubscription(): Promise<CustomerSubscriptionSummary | null> {
    const res = await api.get<CustomerSubscriptionSummary | null>('/dealer/subscription')
    return unwrap(res)
  },

  async getPermissions(): Promise<CustomerPermissionsSummary> {
    const res = await api.get<CustomerPermissionsSummary>('/dealer/permissions')
    return unwrap(res)
  },
}
